import { render, staticRenderFns } from "./new_leads.vue?vue&type=template&id=3e97f445&scoped=true"
import script from "./new_leads.vue?vue&type=script&lang=js"
export * from "./new_leads.vue?vue&type=script&lang=js"
import style0 from "./new_leads.vue?vue&type=style&index=0&id=3e97f445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e97f445",
  null
  
)

export default component.exports